import { withSelectable } from '../SelectContent/withSelectable';
import { LearningPlanReadonlyCard } from './LearningPlanReadonlyCard';
import React from 'react';
import { ILearningPlanReadonlyCard } from '../../entities/Card';

export const SelectableLearningPlanCard = withSelectable<
  React.PropsWithChildren<ILearningPlanReadonlyCard>
>(LearningPlanReadonlyCard);
